// extracted by mini-css-extract-plugin
export default {"Intro":"Intro_Intro__Ntw4E","Content":"Intro_Content__+wwGl","Image":"Intro_Image__wzqxj","Title":"Intro_Title__VdvBC","Text":"Intro_Text__rOQ0b"};